<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" id="prologue">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">PROLOGUE</h1>
</div>
<div class="heading-ornament-block heading-ornament-aspect-wide">
<div class="heading-ornament-size-container">
<img alt="" class="heading-ornament-image" src="images/heading-swash-ornate-screen.png"/>
</div>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<p class="first first-in-chapter first-full-width first-with-first-letter-s"><span class="drop-cap">S</span>tanding at the height of the floodwall overlooking the dark, ballast-paved street of Savannah’s historic waterfront, two impeccably dressed men stood unobserved as they watched Carl Moulton hand over the purse he’d just retrieved from a young thief.</p>
<p class="subsq">The glum manner in which Carl thrust the purse at its grateful owner suggested he was tempted to keep it for himself; only the woman had been joined by a gaggle of friends who’d witnessed Carl’s heroic act.</p>
<p class="subsq">As the original thief crested the steps of the floodwall stairs holding his bloody nose, the taller of the two men passed him a hundred-dollar bill for his trouble.</p>
<p class="subsq">“Well, Carl did the right thing,” the shorter man observed as the boy hurried off.</p>
<p class="subsq">“I thought he might.” Actually, the taller man had been holding his breath until Carl actually surrendered the prize. How reassuring to discover his biological son had a noble bone in his body.</p>
<p class="subsq">“He didn’t need to bludgeon that boy half to death, though.”</p>
<p class="subsq">“True, but the boy’s been compensated. All that matters is Carl made the right choice. He has the heart of a Centurion.”</p>
<p class="subsq">His lawyer made a scoffing sound. “That’s not what the foreman on the jobsite says.”</p>
<p class="subsq">“He’s all I’ve got, Lynwood. You know the rule. Only a son can step into my shoes.”</p>
<p class="subsq">“Then I advise a trial period, Jared. Don’t tell Carl who he is. Give him a job in your home and watch him.”</p>
<p class="subsq">Jared Jones nodded thoughtfully. “Very well. I’ll hire him as a gardener. Come with me, Lyn.” He didn’t fully trust Carl Moulton not to rob him if he approached him alone.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?01eaacbe